import request from "@/util/http";
/**
 * 列表
 */
export function list(query) {
	return request({
		url: '/upms/shop/point/list',
		method: 'get',
		params: query,
	})
}


/**
 * 列表
 */
export function list_json(query) {
	return request({
		url: '/upms/shop/point/list_json',
		method: 'get',
		params: query,
	})
}


// module.exports = {
// 	list,
// 	list_json,
// }
